import { requestAPI } from 'utils/api'

export const deleteAccounts = (params: { type: any, value: any }) => {
  return requestAPI({
    method: 'DELETE', url: '/qa/deleteaccounts', params
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}


export const sendTestPush = (params: { account_ulid: any }) => {
  return requestAPI({
    method: 'POST', url: '/fcm/push/testdecvip', params
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}
